import { createTypes } from '../../utils/helpers';

const MANUFACTURERS_FETCH_ENTITIES: any = createTypes(
  'MANUFACTURERS_FETCH_ENTITIES',
);
const MANUFACTURERS_FETCH_ALL_ENTITIES: any = createTypes(
  'MANUFACTURERS_FETCH_ALL_ENTITIES',
);
const MANUFACTURERS_FETCH_ENTITIES_CATALOG: any = createTypes(
  'MANUFACTURERS_FETCH_ENTITIES_CATALOG',
);
const MANUFACTURERS_CREATE_ENTITY: any = createTypes(
  'MANUFACTURERS_CREATE_ENTITY',
);
const MANUFACTURERS_EDIT_ENTITY: any = createTypes('MANUFACTURERS_EDIT_ENTITY');
const MANUFACTURERS_DELETE_ENTITY: any = createTypes(
  'MANUFACTURERS_DELETE_ENTITY',
);
const MANUFACTURERS_CLEAR_ENTITIES = 'MANUFACTURERS_CLEAR_ENTITIES';
const MANUFACTURERS_SET_ROWS_PER_PAGE = 'MANUFACTURERS_SET_ROWS_PER_PAGE';
const MANUFACTURERS_SET_PAGE = 'MANUFACTURERS_SET_PAGE';
const MANUFACTURERS_DELETE_MANUFACTURER = 'MANUFACTURERS_DELETE_MANUFACTURER';

export {
  MANUFACTURERS_FETCH_ENTITIES,
  MANUFACTURERS_CREATE_ENTITY,
  MANUFACTURERS_EDIT_ENTITY,
  MANUFACTURERS_DELETE_ENTITY,
  MANUFACTURERS_SET_PAGE,
  MANUFACTURERS_FETCH_ALL_ENTITIES,
  MANUFACTURERS_CLEAR_ENTITIES,
  MANUFACTURERS_SET_ROWS_PER_PAGE,
  MANUFACTURERS_DELETE_MANUFACTURER,
  MANUFACTURERS_FETCH_ENTITIES_CATALOG,
};
